import { observable, makeAutoObservable } from 'mobx';
import { SelectValueType } from './ParticipantsInput';
import { RoleObjectType } from './ParticipantsInputGroup.state';

interface RoleObjectInnerType {
    role?: string;
    participant?: SelectValueType;
}

export class ParticipantsInputTwoParticipantsState {
    @observable.ref value: Array<RoleObjectInnerType> = [];

    constructor() {
        makeAutoObservable(this);
    }

    findByRole(role: string): RoleObjectInnerType | undefined {
        return this.value.filter((v) => v.role === role)[0];
    }

    changeByRole(role: string, id: SelectValueType | null): Array<RoleObjectType> {
        const el = this.findByRole(role);

        const value = [...this.value];

        if (el === undefined) {
            value.push({
                role,
                participant: id ?? undefined,
            });
        } else {
            el.participant = id ?? undefined;
        }

        this.value = value;

        return value.map((item) => ({
            role: item.role,
            participant: item.participant?.id,
            name: item.participant?.label,
        }));
    }
}
